"use strict";

// Аккордеон
function accordion() {
    var items = document.querySelectorAll('.accordion__item-trigger');

    // Function to handle click
    function handleItemClick(event) {
        var item = event.target.closest('.accordion__item');
        if (item.classList.contains('accordion__item-active')) {
            item.classList.remove('accordion__item-active');
        } else {
            document.querySelectorAll('.accordion__item-active').forEach(function (activeItem) {
                return activeItem.classList.remove('accordion__item-active');
            });
            item.classList.add('accordion__item-active');
        }
    }

    // Add event listeners only for screen width less than 768px
    function updateAccordion() {
        if (window.innerWidth < 768) {
            items.forEach(function (item) {
                return item.addEventListener('click', handleItemClick);
            });
        } else {
            items.forEach(function (item) {
                return item.removeEventListener('click', handleItemClick);
            });
        }
    }

    // Initial check
    updateAccordion();

    // Update listeners on window resize
    window.addEventListener('resize', updateAccordion);
}
accordion();
